import { ValidationProps } from 'ui';

export const getValidationForId = (
  validation: { [key: string]: ValidationProps },
  id: number
) => {
  return Object.keys(validation || {})
    .reduce((result, key) => {
      const messages = validation[key].messages?.filter(message => message.parameters?.id === id);

      return messages?.length ?? 0 > 0
        ? {
          ...result,
          [key]: {
            ...validation[key],
            messages
          }
        }
        : result;
    }, {} as { [key: string]: ValidationProps });
};

export const clearValidationForId = (
  validation: { [key: string]: ValidationProps },
  id: number
) => {
  return Object.keys(validation || {})
    .reduce((result, key) => {
      const messages = validation[key].messages?.filter(message => message.parameters?.id !== id);

      return messages?.length ?? 0 > 0
        ? {
          ...result,
          [key]: {
            ...validation[key],
            messages
          }
        }
        : result;
    }, {} as { [key: string]: ValidationProps });
};
